<template>
  <b-overlay :show="categories === null" rounded="sm">
    <div v-if="categories !== null">
      <!-- Table Container Card -->
      <b-card class="mb-0">
        <h1 class="mb-2">لیست دسته بندی برای آگهی های مجازی</h1>
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <b-col
              cols="12"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <b-button
                variant="primary"
                @click="addNewCategory = !addNewCategory"
              >
                <span class="text-nowrap">+ ساخت دسته بندی جدید</span>
              </b-button>
            </b-col>
            <!--   new Category name  -->
            <transition name="fade">
              <b-col
                v-if="addNewCategory"
                cols="12"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0 mt-1"
              >
                <b-col md="8">
                  <div class="form-label-group">
                    <b-form-input
                      class="mb-2"
                      id="name"
                      placeholder="نام دسته بندی"
                      v-model="categoryTitle"
                    />
                    <b-form-input
                      id="name"
                      placeholder="توضیحات دسته بندی"
                      v-model="categoryDescription"
                    />
                  </div>
                </b-col>
                <b-col md="2" class="mb-1">
                  <b-button @click="createVirtualCategory" variant="success">
                    <span class="text-nowrap">ساخت</span>
                  </b-button>
                </b-col>
              </b-col>
            </transition>
          </b-row>
        </div>

        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="categories"
          responsive
          :fields="myTableColumns"
          primary-key="id"
          show-empty
          bordered
          striped
          empty-text="موردی موجود نیست!"
        >
          <!-- Column: delete -->

          <template #cell(delete)="data">
            <div
              class="cursor-pointer d-flex flex-row"
              v-b-modal.modal-delete
              @click="showModal(data.item.virtualCategoryId)"
            >
              <feather-icon size="20" icon="TrashIcon" class="text-danger" />
            </div>
          </template>

          <template #cell(edit)="data">
            <feather-icon
              v-b-modal.modal-edit
              size="20"
              class="text-primary cursor-pointer"
              icon="EditIcon"
              @click="setEditItem(data.item)"
            />
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
    <b-modal
      id="modal-delete"
      centered
      ok-title="حذف"
      cancelTitle="انصراف"
      @ok="deleteCategory(deleteItem)"
    >
      <span>حذف شود؟</span>
    </b-modal>
    <b-modal
      id="modal-edit"
      centered
      title="ویرایش دسته بندی"
      ok-title="ویرایش"
      cancelTitle="انصراف"
      @ok="editCategory"
    >
      <b-form-input
        v-if="editItem"
        class="mb-2"
        id="name"
        placeholder="نام دسته بندی"
        v-model="editItem.title"
      />
      <b-form-input
        v-if="editItem"
        class="mb-2"
        id="description"
        placeholder="توضیحات دسته بندی"
        v-model="editItem.description"
      />
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
  BModal,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import VirtualCategoriesGetAll from "@/libs/Api/Categories/VirtualCategories/GetAllVirtualCategories";
import VirtualCategoriesCreate from "@/libs/Api/Categories/VirtualCategories/CreateAVirtualCategory";
import VirtualCategoryDeleteRequest from "@/libs/Api/Categories/VirtualCategories/DeleteAVirtualCategory";
import UpdateAVirtualCategory from "@/libs/Api/Categories/VirtualCategories/UpdateAVirtualCategory";

// import BlogCategoryCreateRequest from "@/libs/Api/Blog/ProductCategoryCreateRequest";
// import BlogCategoryDeleteRequest from "@/libs/Api/Blog/BlogCategoryDeleteRequest";

export default {
  name: "categories-list",
  title: "دسته بندی های مجازی - پنل ادمین فرادیدار",
  data() {
    return {
      categories: null,
      totalCount: null,
      addNewCategory: false,
      deleteItem: null,
      currentPage: 1,
      perPage: 10,
      myTableColumns: [
        { key: "virtualCategoryId", label: "شناسه" },
        { key: "title", label: "نام" },
        { key: "description", label: "توضیحات" },
        { key: "delete", label: "حذف" },
        { key: "edit", label: "ویرایش" },
      ],
      defaultCreateData: {
        title: null,
        seoTitle: null,
        description: null,
        seoDescription: null,
      },
      editItem: null,
    };
  },
  async created() {
    await this.getVirtualCategories();
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BModal,

    vSelect,
  },
  methods: {
    async editCategory() {
      let _this = this;

      let updateAVirtualCategory = new UpdateAVirtualCategory(_this);
      updateAVirtualCategory.setRequestParamDataObj(_this.editItem);
      await updateAVirtualCategory.fetch(
        function (content) {
          _this.$toast({
            component: ToastificationContent,
            position: "bottom-center",
            props: {
              title: `عملیات موفق`,
              icon: "CheckIcon",
              variant: "success",
              text: `دسته بندی ویرایش شد.`,
            },
          });
          _this.getVirtualCategories();
        },
        function (content) {
          console.log(content);
        }
      );
    },
    setEditItem(item) {
      this.editItem = item;
    },
    async getVirtualCategories() {
      let _this = this;

      let virtualCategoriesGetAll = new VirtualCategoriesGetAll(_this);
      await virtualCategoriesGetAll.fetch(
        function (content) {
          _this.categories = content.virtualCategories;
        },
        function (content) {
          console.log(content);
        }
      );
    },
    async createVirtualCategory() {
      let _this = this;

      let virtualCategoriesCreate = new VirtualCategoriesCreate(_this);
      virtualCategoriesCreate.setParams(_this.defaultCreateData);
      await virtualCategoriesCreate.fetch(
        function (content) {
          _this.$toast({
            component: ToastificationContent,
            position: "bottom-center",
            props: {
              title: `عملیات موفق`,
              icon: "CheckIcon",
              variant: "success",
              text: `دسته بندی جدید اضافه شد.`,
            },
          });
          _this.getVirtualCategories();
        },
        function (error) {
          console.log(error);
        }
      );
    },
    async deleteCategory(param) {
      let _this = this;

      let virtualCategoryDeleteRequest = new VirtualCategoryDeleteRequest(
        _this
      );
      virtualCategoryDeleteRequest.setId(param);
      await virtualCategoryDeleteRequest.fetch(
        function (content) {
          _this.$toast({
            component: ToastificationContent,
            position: "bottom-center",
            props: {
              title: `عملیات موفق`,
              icon: "CheckIcon",
              variant: "success",
              text: `دسته بندی حذف شد.`,
            },
          });
          _this.getVirtualCategories();
        },
        function (error) {
          console.log(error);
        }
      );
    },
    showModal(param) {
      let _this = this;
      _this.deleteItem = param;
    },
  },
  computed: {
    categoryTitle: {
      get() {
        return this.defaultCreateData.title;
      },
      set(newValue) {
        this.defaultCreateData.title = newValue;
        this.defaultCreateData.seoTitle = newValue;
      },
    },
    categoryDescription: {
      get() {
        return this.defaultCreateData.description;
      },
      set(newValue) {
        this.defaultCreateData.description = newValue;
        this.defaultCreateData.seoDescription = newValue;
      },
    },
  },
};
</script>

<style scoped></style>
